import React from "react";
import Icon from "../../../components/AppIcon";
import { roundTo } from "../../../components/utils/mathUtils";
import { useConfig } from "../../../context/ConfigContext";
import { formatNumber, formatNumberQTZ } from "../../../components/utils/format";

const StatsOverview = ({ projects }) => {
  const config = useConfig();
  const {
    ENERGIA_TOTAL,
    PLANTAS_SOLARES,
    AHORRO_TOTAL,
    CALIFICACION_PROMEDIO,
    CO2_TOTAL,
    CARBON_TOTAL,
    CARS_OFF_TOTAL,
    TOTAL_ARBOLES,
  } = config;
  const statItems = [
    {
      icon: "Building2",
      label: "Proyectos Completados",
      value: `${roundTo(PLANTAS_SOLARES)}+`,
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      icon: "Zap",
      label: "Capacidad Instalada",
      value: `${formatNumber(ENERGIA_TOTAL)}Wh`,
      color: "text-accent",
      bgColor: "bg-accent/10",
    },
    {
      icon: "DollarSign",
      label: "Ahorros Generados",
      value: formatNumberQTZ(AHORRO_TOTAL),
      color: "text-success",
      bgColor: "bg-success/10",
    },
    {
      icon: "Star",
      label: "Calificación Promedio",
      value: `${CALIFICACION_PROMEDIO}/5.0`,
      color: "text-amber-500",
      bgColor: "bg-amber-50",
    },
  ];

  return (
    <div className="bg-white rounded-xl solar-shadow-card p-6 mb-8">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-foreground mb-2">
          Nuestro Impacto en Guatemala
        </h2>
        <p className="text-muted-foreground">
          Transformando el panorama energético guatemalteco, un proyecto a la
          vez
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {statItems?.map((stat, index) => (
          <div
            key={index}
            className="text-center p-4 rounded-lg solar-hover-lift solar-transition"
          >
            <div
              className={`inline-flex items-center justify-center w-12 h-12 rounded-full ${stat?.bgColor} mb-3`}
            >
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
            <div className="text-2xl font-bold text-foreground mb-1">
              {stat?.value}
            </div>
            <div className="text-sm text-muted-foreground">{stat?.label}</div>
          </div>
        ))}
      </div>

      {/* Environmental Impact */}
      <div className="mt-8 pt-6 border-t">
        <div className="text-center">
          <h3 className="text-lg font-semibold text-foreground mb-4">
            Impacto Ambiental Acumulado
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
            <div className="p-4 bg-secondary/5 rounded-lg">
              <div className="text-xl font-bold text-secondary">
                {roundTo(CO2_TOTAL)} (t)
              </div>
              <div className="text-sm text-muted-foreground">CO₂ Evitado</div>
            </div>
            <div className="p-4 bg-primary/5 rounded-lg">
              <div className="text-xl font-bold text-primary">
                {roundTo(CARBON_TOTAL)} (t)
              </div>
              <div className="text-sm text-muted-foreground">
                Emisión de carbón evitado
              </div>
            </div>
            <div className="p-4 bg-secondary/5 rounded-lg">
              <div className="text-xl font-bold text-secondary">
                {TOTAL_ARBOLES}
              </div>
              <div className="text-sm text-muted-foreground">
                Arboles plantados
              </div>
            </div>
            <div className="p-4 bg-accent/5 rounded-lg">
              <div className="text-xl font-bold text-accent">
                {formatNumber(CARS_OFF_TOTAL)}
              </div>
              <div className="text-sm text-muted-foreground">
                Autos fuera de circulación
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsOverview;
